function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26439",
  "data-name": "Group 26439",
  transform: "translate(217.81 1788.735)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_1185",
  "data-name": "Trazado 1185",
  d: "M856.357,456.483q-.97-7.814-1.933-15.631a12.8,12.8,0,0,1-.015-1.474,5.664,5.664,0,0,1,2.933-3.507,12.559,12.559,0,0,1,5.262-1.382,1.5,1.5,0,0,1,1.411.839,17.777,17.777,0,0,1,1.727,3.607c1.875,4.874,3.349,9.889,5.234,14.76a28.932,28.932,0,0,0,5.548,9.282c2.9,3.173,5.612,6.515,8.41,9.778a6.012,6.012,0,0,1,1.2,1.906c2.968,8.522,6.1,16.989,8.757,25.616a31.722,31.722,0,0,1,1.146,4.371,1.536,1.536,0,0,0,.525.865c3.166,3.2,6.381,6.355,9.482,9.622a15.9,15.9,0,0,1,4.013,15.935,3.541,3.541,0,0,1-.384.964c-4,6.411-8.13,12.734-13.258,18.328a21.747,21.747,0,0,1-4.176,3.676,3.68,3.68,0,0,1-4.494.018c-5.929-3.9-11.693-8.016-17.247-12.426a9.6,9.6,0,0,0-4.8-2.06,86.367,86.367,0,0,1-8.476-1.943c-3.231-1.082-6.488-2.091-9.637-3.4-1.839-.767-3.665-1.564-5.5-2.348,2.1-.439,4.245-.556,6.369-.82,4.031-.5,8.073-.922,12.1-1.438a4.514,4.514,0,0,0,3.751-5.146c-.275-2.54-.6-5.074-.9-7.612q-1.19-10.075-2.377-20.15-1.369-11.579-2.741-23.159c-.142-1.179-.236-2.364-.355-3.545l4.738,1.843A77.871,77.871,0,0,1,856.357,456.483Z",
  transform: "translate(-768.554 -401.266)",
  fill: "#e49963"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_1191",
  "data-name": "Trazado 1191",
  d: "M701.671,319.9c-1.248.059-1.939-.455-2.037-1.338a1.573,1.573,0,0,1,1.344-1.773q.074-.01.149-.013,3.456-.425,6.916-.817a1.616,1.616,0,0,1,1.83,1.358,1.57,1.57,0,0,1-1.355,1.76l-.063.007C706.119,319.4,703.781,319.654,701.671,319.9Z",
  transform: "translate(-655.99 -307.609)",
  fill: "#e49963"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_25985",
  "data-name": "Group 25985",
  transform: "translate(92.061 61.789)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13787",
  "data-name": "Path 13787",
  d: "M130.525,44.92a7.665,7.665,0,0,1,7.656,7.651l.052,119.16a7.656,7.656,0,0,1-7.647,7.654l-49.944.021a7.655,7.655,0,0,1-7.654-7.647L72.935,52.6a7.656,7.656,0,0,1,7.645-7.656Z",
  transform: "translate(-72.375 -44.92)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_25981",
  "data-name": "Group 25981",
  transform: "translate(0 26.939)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13788",
  "data-name": "Path 13788",
  d: "M72.507,80.027c0,.5.255.911.563.91s.562-.409.559-.912l-.005-13.378c0-.5-.252-.914-.562-.912s-.558.409-.56.912Z",
  transform: "translate(-72.502 -65.734)",
  fill: "#ebebeb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25982",
  "data-name": "Group 25982",
  transform: "translate(65.478 36.779)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13789",
  "data-name": "Path 13789",
  d: "M123.1,81.992c0,.5.236.911.528.911s.528-.41.528-.912l-.005-7.744c0-.5-.237-.91-.528-.911s-.528.41-.528.914Z",
  transform: "translate(-123.092 -73.336)",
  fill: "#ebebeb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25983",
  "data-name": "Group 25983",
  transform: "translate(65.476 26.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13790",
  "data-name": "Path 13790",
  d: "M123.093,73.663c0,.5.237.911.528.91s.527-.41.528-.91l0-7.745c0-.5-.238-.91-.529-.909s-.525.409-.525.909Z",
  transform: "translate(-123.09 -65.009)",
  fill: "#ebebeb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25984",
  "data-name": "Group 25984",
  transform: "translate(65.469 17.045)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13791",
  "data-name": "Path 13791",
  d: "M123.089,64.161c0,.5.237.91.528.909s.528-.412.527-.91l0-5.16c0-.5-.237-.912-.528-.91s-.527.409-.528.91Z",
  transform: "translate(-123.085 -58.089)",
  fill: "#ebebeb"
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_25986",
  "data-name": "Group 25986",
  transform: "translate(91.316 60.861)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13792",
  "data-name": "Path 13792",
  d: "M72.98,171.676a7.311,7.311,0,0,0,7.291,7.288l49.943-.026a7.306,7.306,0,0,0,7.284-7.292l-.052-119.16a7.309,7.309,0,0,0-7.292-7.283l-49.944.021a7.305,7.305,0,0,0-7.283,7.292Z",
  transform: "translate(-71.633 -43.909)",
  fill: "#a88fdd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13793",
  "data-name": "Path 13793",
  d: "M80.565,180.553a8.6,8.6,0,0,1-8.585-8.582L71.927,52.81A8.6,8.6,0,0,1,80.5,44.224l49.944-.021h.008a8.592,8.592,0,0,1,8.579,8.576l.052,119.162a8.6,8.6,0,0,1-8.579,8.586ZM130.456,46.792h-.006l-49.944.021a6.012,6.012,0,0,0-5.99,6l.053,119.163a6,6,0,0,0,6,5.994l49.942-.026a6.012,6.012,0,0,0,5.991-6l-.052-119.16A6,6,0,0,0,130.456,46.792Z",
  transform: "translate(-71.927 -44.203)"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_13815",
  "data-name": "Path 13815",
  d: "M87.034,105.307a3.505,3.505,0,0,0,3.5,3.495l59.275-.16c0-.7.053-24.98.053-24.98a3.5,3.5,0,0,0-3.5-3.495H90.53a3.5,3.5,0,0,0-3.5,3.495Z",
  transform: "translate(23.835 72.242)",
  fill: "#bf76ff"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26025",
  "data-name": "Group 26025",
  transform: "translate(115.626 157.693)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26017",
  "data-name": "Group 26017"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26011",
  "data-name": "Group 26011"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13816",
  "data-name": "Path 13816",
  d: "M100.328,84.25H91.356a.647.647,0,0,0,0,1.294h8.972a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-90.709 -84.25)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26012",
  "data-name": "Group 26012",
  transform: "translate(13.815)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13817",
  "data-name": "Path 13817",
  d: "M120.634,84.25h-18.6a.647.647,0,1,0,0,1.294h18.6a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-101.383 -84.25)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26013",
  "data-name": "Group 26013",
  transform: "translate(37.263)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13818",
  "data-name": "Path 13818",
  d: "M134.9,84.25h-14.75a.647.647,0,0,0,0,1.294H134.9a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-119.499 -84.25)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26014",
  "data-name": "Group 26014",
  transform: "translate(0.215 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13819",
  "data-name": "Path 13819",
  d: "M106.623,88.583h-15.1a.647.647,0,0,0,0,1.294h15.1a.647.647,0,0,0,0-1.294Z",
  transform: "translate(-90.875 -88.583)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26015",
  "data-name": "Group 26015",
  transform: "translate(20.169 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13820",
  "data-name": "Path 13820",
  d: "M128.079,88.583h-21.14a.647.647,0,1,0,0,1.294h21.14a.647.647,0,0,0,0-1.294Z",
  transform: "translate(-106.292 -88.583)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26016",
  "data-name": "Group 26016",
  transform: "translate(45.739 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13821",
  "data-name": "Path 13821",
  d: "M133.054,88.583H126.7a.647.647,0,0,0,0,1.294h6.359a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-126.048 -88.583)",
  fill: "#e9d5fa"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_26024",
  "data-name": "Group 26024",
  transform: "translate(0 11.434)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26018",
  "data-name": "Group 26018"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13822",
  "data-name": "Path 13822",
  d: "M100.328,93.084H91.356a.647.647,0,0,0,0,1.294h8.972a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-90.709 -93.084)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26019",
  "data-name": "Group 26019",
  transform: "translate(13.815)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13823",
  "data-name": "Path 13823",
  d: "M120.634,93.084h-18.6a.647.647,0,1,0,0,1.294h18.6a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-101.383 -93.084)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26020",
  "data-name": "Group 26020",
  transform: "translate(37.263)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13824",
  "data-name": "Path 13824",
  d: "M134.9,93.084h-14.75a.647.647,0,0,0,0,1.294H134.9a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-119.499 -93.084)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26021",
  "data-name": "Group 26021",
  transform: "translate(0.215 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13825",
  "data-name": "Path 13825",
  d: "M106.623,97.417h-15.1a.647.647,0,0,0,0,1.294h15.1a.647.647,0,0,0,0-1.294Z",
  transform: "translate(-90.875 -97.417)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26022",
  "data-name": "Group 26022",
  transform: "translate(20.169 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13826",
  "data-name": "Path 13826",
  d: "M128.079,97.417h-21.14a.647.647,0,1,0,0,1.294h21.14a.647.647,0,0,0,0-1.294Z",
  transform: "translate(-106.292 -97.417)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_26023",
  "data-name": "Group 26023",
  transform: "translate(45.739 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13827",
  "data-name": "Path 13827",
  d: "M133.054,97.417H126.7a.647.647,0,0,0,0,1.294h6.359a.647.647,0,1,0,0-1.294Z",
  transform: "translate(-126.048 -97.417)",
  fill: "#e9d5fa"
}))));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26029",
  "data-name": "Group 26029",
  transform: "translate(176.615 168.315)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26027",
  "data-name": "Group 26027"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26026",
  "data-name": "Group 26026"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13828",
  "data-name": "Path 13828",
  d: "M137.831,98.821a6.364,6.364,0,1,0,6.364-6.364A6.363,6.363,0,0,0,137.831,98.821Z",
  transform: "translate(-137.831 -92.457)",
  fill: "#5a3cb4"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_26028",
  "data-name": "Group 26028",
  transform: "translate(2.894 2.519)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13829",
  "data-name": "Path 13829",
  d: "M141.388,96.162a1.759,1.759,0,1,0,1.759-1.759A1.759,1.759,0,0,0,141.388,96.162Z",
  transform: "translate(-139.678 -94.403)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13830",
  "data-name": "Path 13830",
  d: "M140.086,100.049a3.665,3.665,0,0,1,3.444-2.445h.012a3.666,3.666,0,0,1,3.444,2.445.328.328,0,0,1-.349.449h-6.2A.329.329,0,0,1,140.086,100.049Z",
  transform: "translate(-140.067 -93.461)",
  fill: "#fff"
})));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2609",
  "data-name": "Rectangle 2609",
  d: "M0,0H31.812a0,0,0,0,1,0,0V4.091a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z",
  transform: "translate(108.99 61.809)"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "home",
  transform: "translate(-331.061 1187.751)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25767",
  "data-name": "Group 25767",
  transform: "translate(590.5 638.896)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13534",
  "data-name": "Path 13534",
  d: "M633.828,672.763a38.419,38.419,0,0,0-13.343,2.127,17.771,17.771,0,0,0-1.712.76c3.4,1.2,8.976,1.956,15.055,1.956s11.665-.757,15.057-1.954a17.686,17.686,0,0,0-1.714-.762A38.419,38.419,0,0,0,633.828,672.763Z",
  transform: "translate(-615.479 -668.818)",
  fill: "#e9d5fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13535",
  "data-name": "Path 13535",
  d: "M608.849,642.143a39.125,39.125,0,0,1,13.595,2.174,17.623,17.623,0,0,1,2.323,1.081,6.765,6.765,0,0,0,1.854-1.095,1.438,1.438,0,0,0,.578-1.012c0-1.047-1.939-2.169-5.187-3a62.845,62.845,0,0,0-26.324,0c-3.248.832-5.187,1.953-5.187,3a1.463,1.463,0,0,0,.6,1.035,6.867,6.867,0,0,0,1.83,1.071,17.608,17.608,0,0,1,2.321-1.08A39.124,39.124,0,0,1,608.849,642.143Z",
  transform: "translate(-590.5 -638.896)",
  fill: "#e9d5fa"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13536",
  "data-name": "Path 13536",
  d: "M688.256,765.245v7.015l-.61.2-.61.2-.78.256a.6.6,0,0,0-.386.532v.76a.408.408,0,0,0,.406.407h14.27a.408.408,0,0,0,.407-.407v-.76a.6.6,0,0,0-.386-.532l-.78-.256-.61-.2-.61-.2v-7.015h-1.487v5.239h-7.336v-5.239Z",
  transform: "translate(-84.259 -109.898)",
  fill: "#e9d5fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13537",
  "data-name": "Path 13537",
  d: "M593.94,693.932l1.927,10.367a1.35,1.35,0,0,0,.37.675c1.3,1.089,4.093,2.4,9.576,2.979v-5.934A1.016,1.016,0,0,1,606.828,701H617.55a1.016,1.016,0,0,1,1.016,1.016v5.946c5.507-.565,8.283-1.853,9.62-2.991a1.3,1.3,0,0,0,.374-.671l1.3-10.387c-2.693,1.992-9.779,3.311-17.972,3.311C603.731,697.227,596.649,695.914,593.94,693.932Z",
  transform: "translate(-3.039 -48.61)",
  fill: "#e9d5fa"
}));
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2677",
  "data-name": "Rectangle 2677",
  width: 28.499,
  height: 14.816,
  rx: 7.408,
  transform: "translate(234.12 1810.2) rotate(38.606)",
  fill: "#e49963"
});
var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2678",
  "data-name": "Rectangle 2678",
  width: 29.403,
  height: 14.816,
  rx: 7.408,
  transform: "translate(227.424 1847.977) rotate(18.573)",
  fill: "#e49963"
});
var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2679",
  "data-name": "Rectangle 2679",
  width: 15.904,
  height: 11.961,
  rx: 5.98,
  transform: "translate(243.04 1893.28) rotate(21.589)",
  fill: "#e49963"
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2680",
  "data-name": "Rectangle 2680",
  width: 27.207,
  height: 13.669,
  rx: 6.835,
  transform: "translate(232.292 1870.702) rotate(21.589)",
  fill: "#e49963"
});
var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26440",
  "data-name": "Group 26440",
  transform: "translate(216.011 1865.685)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25988",
  "data-name": "Group 25988"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25987",
  "data-name": "Group 25987"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_330",
  "data-name": "Ellipse 330",
  cx: 6.364,
  cy: 6.364,
  r: 6.364,
  fill: "#bf76ff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_25989",
  "data-name": "Group 25989",
  transform: "translate(2.894 2.518)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13794",
  "data-name": "Path 13794",
  d: "M56.319,67.538a1.76,1.76,0,1,1-1.759-1.76A1.759,1.759,0,0,1,56.319,67.538Z",
  transform: "translate(-51.09 -65.778)",
  fill: "#e9d5fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13795",
  "data-name": "Path 13795",
  d: "M58.4,71.424a3.667,3.667,0,0,0-3.444-2.445h-.012A3.667,3.667,0,0,0,51.5,71.424a.328.328,0,0,0,.349.449h6.2A.329.329,0,0,0,58.4,71.424Z",
  transform: "translate(-51.478 -64.836)",
  fill: "#e9d5fa"
})));
var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_13925",
  "data-name": "Path 13925",
  d: "M124.158,74.144a3.505,3.505,0,0,1-3.5,3.5l-59.275-.162c0-.7-.053-13.817-.053-13.817a3.5,3.5,0,0,1,3.5-3.495h55.832a3.5,3.5,0,0,1,3.5,3.495Z",
  transform: "translate(170.327 1800.774)",
  fill: "#29ed87"
});
var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26441",
  "data-name": "Group 26441",
  transform: "translate(236.323 1866.226)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25997",
  "data-name": "Group 25997",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25991",
  "data-name": "Group 25991",
  transform: "translate(42.255)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13798",
  "data-name": "Path 13798",
  d: "M98.23,65.544h8.791a.647.647,0,0,0,0-1.294H98.23a.647.647,0,1,0,0,1.294Z",
  transform: "translate(-97.583 -64.25)",
  fill: "#392a58"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25992",
  "data-name": "Group 25992",
  transform: "translate(19.281)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13799",
  "data-name": "Path 13799",
  d: "M80.48,65.544H98.709a.647.647,0,1,0,0-1.294H80.48a.647.647,0,0,0,0,1.294Z",
  transform: "translate(-79.833 -64.25)",
  fill: "#392a58"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25993",
  "data-name": "Group 25993",
  transform: "translate(0.083)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13800",
  "data-name": "Path 13800",
  d: "M65.647,65.544H80.1a.647.647,0,0,0,0-1.294H65.647a.647.647,0,1,0,0,1.294Z",
  transform: "translate(-65 -64.25)",
  fill: "#392a58"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25994",
  "data-name": "Group 25994",
  transform: "translate(38.157 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13801",
  "data-name": "Path 13801",
  d: "M95.064,69.877h6.285a.647.647,0,0,0,0-1.294H95.064a.647.647,0,1,0,0,1.294Z",
  transform: "translate(-94.417 -68.583)",
  fill: "#392a58"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25995",
  "data-name": "Group 25995",
  transform: "translate(9.897 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13802",
  "data-name": "Path 13802",
  d: "M73.23,69.877H97.283a.647.647,0,1,0,0-1.294H73.23a.647.647,0,0,0,0,1.294Z",
  transform: "translate(-72.583 -68.583)",
  fill: "#392a58"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_25996",
  "data-name": "Group 25996",
  transform: "translate(0 5.608)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13803",
  "data-name": "Path 13803",
  d: "M65.583,69.877h6.231a.647.647,0,1,0,0-1.294H65.583a.647.647,0,1,0,0,1.294Z",
  transform: "translate(-64.936 -68.583)",
  fill: "#392a58"
}))));
function SvgHowItWorksApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.962,
    height: 146.242,
    viewBox: "0 0 143.962 146.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_26446",
    "data-name": "Group 26446",
    transform: "translate(-216.011 -1796.041)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(153.325 1735.18)"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    id: "Path_13814",
    "data-name": "Path 13814",
    d: "M85.294,106.89a3.505,3.505,0,0,0,3.5,3.495l59.275-.161c0-.7.053-24.98.053-24.98a3.5,3.5,0,0,0-3.5-3.495H88.791a3.5,3.5,0,0,0-3.5,3.495Z",
    transform: "translate(23.323 72.707)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref5, _ref6, _ref7, _ref8), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("path", {
    id: "Path_13924",
    "data-name": "Path 13924",
    d: "M122.574,75.727a3.505,3.505,0,0,1-3.5,3.5L59.8,79.061c0-.7-.052-13.817-.052-13.817a3.5,3.5,0,0,1,3.495-3.495h55.832a3.5,3.5,0,0,1,3.5,3.495Z",
    transform: "translate(169.861 1801.24)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref15, _ref16));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksApp);
export default __webpack_public_path__ + "static/media/howItWorksApp.d61a16f7d44932bfae14c4f6a1610042.svg";
export { ForwardRef as ReactComponent };